import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AnticipateEndDateGovernmentAllocationSchema } from '../schemas/anticipateEndDateGovernmentAllocation.schema'
import { addDays, format } from 'date-fns'

type AnticipateEndDateGovernmentAllocationProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: ErrorResponse) => void
}

export const useAnticipateEndDateGovernmentAllocation = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: AnticipateEndDateGovernmentAllocationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['anticipateEndDateGovernmentAllocation', governmentAllocationId],
    mutationFn: async (form: AnticipateEndDateGovernmentAllocationSchema) => {
      const payload = {
        government_allocation: {
          requested_new_end_date: format(addDays(new Date(form.requested_new_end_date), 1), 'dd/MM/yyyy'),
        },
      }

      return privateAxios.put(`/billing/government_allocations/${governmentAllocationId}/anticipate_end_date`, payload)
    },
    onSuccess,
    onError,
  })
}
